module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAc0lEQVR42u3aQRHAMAACQTREROVVTqTVDhXCMnMG9k3aZrkAAAAAAAAAAAAAAABgbQAAAAAAAAAAAAAAAADQ5L5dCgAAAAAAAAAAAAAAAADSNt9zuhQAAAAAAAAAAAAAAAAAAHCUBAAAAAAAAAAAAABgrh8kIM5RGitwsQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Bulgaria.png
// module id = iAgY
// module chunks = 0 62 63